import validate from "/var/lib/jenkins/workspace/train73.pro/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/var/lib/jenkins/workspace/train73.pro/src/middleware/route.global.ts";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/train73.pro/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}